export enum AuthQueryParamKey {
  TOKEN = 'token',
}
